import useCopyToClipboard from "hooks/useCopyToClipboard";
import DropdownMenuItem, { DropdownMenuItemProps } from "ds/components/DropdownMenu/Item";

type CopyFieldDropdownItem = Omit<DropdownMenuItemProps, "value"> & {
  title: string;
  value: string;
  onCopy?: () => void;
};

const CopyFieldDropdownMenuItem = ({
  title,
  value,
  onCopy,
  ...restProps
}: CopyFieldDropdownItem) => {
  const copyToClipboard = useCopyToClipboard(value, onCopy);

  return (
    <DropdownMenuItem {...restProps} onAction={copyToClipboard}>
      {title}
    </DropdownMenuItem>
  );
};

export default CopyFieldDropdownMenuItem;
